"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerAddressSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class PartnerAddressSearchResponse extends common_1.PaginatedResponse {
}
exports.PartnerAddressSearchResponse = PartnerAddressSearchResponse;
//# sourceMappingURL=partner-address-search.response.js.map